export default __webpack_public_path__ + "static/media/institutionBG.0b568464.jpg";